module.exports = __webpack_public_path__ + "img/9.4febe448.png";